import { animate, onScroll } from 'animejs';

export default () => {
  const fadeElements = document.querySelectorAll('.home-feature__main-copy');

  fadeElements.forEach((e) => {
    animate(e, {
      x: ['80',0],
      opacity: [0,1],
      duration: 2000,
      ease: 'outExpo',
      autoplay: onScroll({
        debug: false,
        enter: 'bottom+=90vh',
        leave: 'top+=10vh',
      })
    })
  })
};
